import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import { useVendor } from '../../DataStore/VendorContext';
import Pagination from '../../components/Common/Pagination';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../DataStore/ThemeContext';
import AlertNotification from '../../components/Common/AlertNotification';


const VendorListingPage = () => {
    const [showProfile, setShowProfile] = useState(false);
    const [selection, setSelelection] = useState(false);

    const {
        metaData, 
        getVendorListing, 
        vendorListing, 
        setCurrentPage, 
        setSelectedVendor, 
        selectedVendor
    } = useVendor();

    const {setNotify, openSettings} = useTheme();

    const navigate = useNavigate()

    useEffect(()=>{
        getVendorListing();
    }, [])

    useEffect(()=>{
        if(selectedVendor && showProfile){
            navigate('/vendor-profile')
        }
    }, [selectedVendor, showProfile])

    const handleNewVendor = ()=>{
        navigate('/vendor-new')
    }

    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-pencil text-success" label="New Vendor" onClick={handleNewVendor}/>
        <ActionDropdownItem iconClass="fa fa-edit text-primary" label="Edit Selection" onClick={handleEdit}/>
        <ActionDropdownItem iconClass="fa fa-refresh text-info" label="Refresh" onClick={()=>getVendorListing(true)}/>
        </>)

    const goToProfile = (profileInfo)=>{
        setSelectedVendor(profileInfo);
        setShowProfile(true);
    }

    const handleEdit = ()=>{

        if (!selection) {
            setNotify(<AlertNotification message="No vendor selected. Please make selection then try again." iconClass="fa fa-info" />);
            return;
        }
        openSettings('Edit Vendor', 'EditVendor', selection);

    }

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Vendor Listing"
                    description="List of all system vendors also known as payees."
                    iconClass="fa fa-truck"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                    /> : <></>}
                />

                <div className="card mb-3">
                    <div className="card-body">

                     <table className="table table-hover">
                        <thead className="table-light">
                            <tr>
                                <th>Title</th> 
                                <th>#Ref</th>
                                <th>Description</th>
                                <th>Contact</th>
                                <th>Email Address</th>
                                <th>Address</th>
                            </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(vendorListing) && vendorListing.map((item, key)=>
                                <tr key={key} onClick={()=>setSelelection(item)} className={`link ${selection.payee_id === item.payee_id ? 'selected-row': ''}`}>
                                    <td>{item.title}</td>
                                    <td><span className="link text-primary" onClick={()=>goToProfile(item)}>{item.ref}</span></td>
                                    <td>{item.description}</td>
                                    <td>{item.phone_number}</td>
                                    <td>{item.email}</td>
                                    <td>{item.address}</td>

                                </tr>
                                )}
                                </tbody>
                            </table>
                            {!vendorListing && <ActivityLoader />}
                            {vendorListing === "404" && <Notification message="No vendor record found" closable={false} />}
                       
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default VendorListingPage;
